import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: null,

  createStatus: '',
  updateStatus: '',
  deleteStatus: '',

  statistics: null,
  deposits: null,
  withdrawals: null,
};

export const utmSlice = createSlice({
  name: 'utm',
  initialState,
  reducers: {
    setUtms: (state, action) => {
      state.list = action.payload;
    },

    setCreateUtmStatus: (state, action) => {
      state.createStatus = action.payload;
    },
    setUpdateUtmStatus: (state, action) => {
      state.updateStatus = action.payload;
    },
    setDeleteUtmStatus: (state, action) => {
      state.deleteStatus = action.payload;
    },

    setUtmStatistics: (state, action) => {
      state.statistics = action.payload;
    },
    setUtmDeposits: (state, action) => {
      state.deposits = action.payload;
    },
    setUtmWithdrawals: (state, action) => {
      state.withdrawals = action.payload;
    },

    resetUtm: () => initialState,
  },
});

export const {
  setUtms,

  setCreateUtmStatus,
  setUpdateUtmStatus,
  setDeleteUtmStatus,

  setPartnerTransactions,

  setUtmStatistics,
  setUtmDeposits,
  setUtmWithdrawals,

  resetUtm,
} = utmSlice.actions;

export default utmSlice.reducer;
